import React, { Component } from 'react'
import sectiondata from '../../data/sections.json'
import parse from 'html-react-parser'
import SwiperCore, {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Autoplay,
} from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/swiper.scss'
import 'swiper/components/navigation/navigation.scss'
import 'swiper/components/pagination/pagination.scss'

function Team({ data }) {
  let publicUrl = process.env.PUBLIC_URL + '/'
  let imagealt = 'image'
  // let data = sectiondata.team
  console.log(data?.team)

  return (
    <div className='team-area bg-gray mg-top-70 pd-top-90 pd-bottom-70'>
      {/* <div className="section-title text-center">
            <h2 className="title">{data.title}</h2>
          </div> */}
      <div className='px-4'>
        <div className='row'>
          <Swiper
            autoplay={{ delay: 3000 }}
            navigation
            loop={true}
            pagination={{ clickable: true }}
            onSwiper={(swiper) => console.log(swiper)}
            onSlideChange={() => console.log('slide change')}
          >
            {data?.team.map((item, i) => (
              <SwiperSlide key={i}>
                <div className='container'>
                  <div key={i} className='col-lg-12 col-sm-12'>
                    <div
                      className=' row single-team'
                      style={{ flexDirection: 'row-reverse' }}
                    >
                      <div
                        className='thumb col-lg-4 col-sm-4'
                        style={{ transform: 'scale(1.08)' }}
                      >
                        <img
                          src={item.image}
                          alt='team'
                          style={{ width: '100%', height: '100%' }}
                        />
                      </div>
                      <div className='team-details col-lg-8 col-sm-8'>
                        <h3>{item.name}</h3>
                        <span>{item.designation}</span>
                        <ul>
                          {item.social.map((social, i) => (
                            <li key={i}>
                              <a href={social.url}>
                                <i className={social.icon} />
                              </a>
                            </li>
                          ))}
                        </ul>
                        <p>{item.content}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  )
}

export default Team
